import { UiText } from '@experiences/ui-common';
import { useShowDialog } from '@experiences/util';
import React from 'react';
import { useIntl } from 'react-intl';

const useShowRestartMessageDialog = () => {
    const createDialog = useShowDialog();
    const { formatMessage: translate } = useIntl();

    return () =>
        createDialog({
            dataCy: 'restart-message-dialog',
            body: (
                <UiText data-cy="">
                    {translate({
                        id: process.buildConfigs.showK8SRestartMessage
                            ? 'CLIENT_EXTERNAL_PROVIDER_DIALOG_RESTART_MESSAGE_K8S'
                            : 'CLIENT_EXTERNAL_PROVIDER_DIALOG_RESTART_MESSAGE',
                    })}
                </UiText>
            ),
            icon: 'warning',
            showCancel: false,
            primaryButtonText: translate({ id: 'CLIENT_OK' }),
        });
};

export default useShowRestartMessageDialog;
